import { getPreviousWeekday } from "@clockwise/web-commons/src/util/getPreviousWeekday";
import { isEqual, noop } from "lodash";
import { DateTime } from "luxon";
import React, { useEffect } from "react";
import {
  parseCalendarForSharedProposalGQL,
  parseTradeoffsFromCalendarForSharedProposalGQL,
} from "../../chat-plus-calendar/util/parseCalendarProposalGQL";
import { GQLProposal } from "../../chat/ai-chat/utils/types";
import { ModifiedPlannerEventCardDiff, PlannerEventCardsByDay } from "../../web-app-calendar/types";

export const useSharedProposalEventCards = (date: string, sharedProposal: GQLProposal | null) => {
  // TODO: useProposal hook instead of fetching here
  const [cardsByDay, setCardsByDay] = React.useState<PlannerEventCardsByDay>({});
  const [modifiedCardDiffs, setModifiedCardDiffs] = React.useState<ModifiedPlannerEventCardDiff[]>(
    [],
  );
  const [weekStartDate, setWeekStartDate] = React.useState<string>("");

  const newWeekStartDate = getPreviousWeekday(DateTime.fromISO(date), "sunday").toISODate();
  if (!isEqual(newWeekStartDate, weekStartDate)) {
    setWeekStartDate(newWeekStartDate);
  }

  const parseProposedTimes = () => {
    if (!sharedProposal) {
      setCardsByDay({});
      return;
    }

    if (sharedProposal.state === "ACTIVE") {
      const newEventsByDay = parseCalendarForSharedProposalGQL(sharedProposal).extract();
      if (newEventsByDay) {
        setCardsByDay({ ...newEventsByDay });
      }
      const newModifiedCardDiffs = parseTradeoffsFromCalendarForSharedProposalGQL(
        sharedProposal,
      ).extract();
      if (newModifiedCardDiffs) {
        setModifiedCardDiffs([...newModifiedCardDiffs]);
      }
    } else {
      setCardsByDay({});
    }
  };

  const isScheduleByMovingProposal = () => {
    return sharedProposal && (sharedProposal.consequencesBlock?.yourCalDiffs || []).length > 0;
  };

  useEffect(() => {
    if (sharedProposal) {
      parseProposedTimes();
    }
  }, [sharedProposal]);

  const refetchAndstartPolling = noop;
  const stopPolling = noop;
  const refetch = noop;
  const prefetch = noop;
  const getEventForCard = () => undefined;
  const loading = false;
  const error = null;

  return {
    cardsByDay,
    loading,
    error,
    modifiedCardDiffs,
    getEventForCard,
    refetch,
    prefetch,
    startPolling: refetchAndstartPolling,
    stopPolling,
    isScheduleByMoving: isScheduleByMovingProposal(),
  };
};
